var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$slots.default || _vm.fields)?_c('div',{staticClass:"table-item"},[_c('table',[_vm._t("default")],2)]):_c('PageLoader'),(_vm.table && _vm.table.pagination)?_c('TablePagination',{attrs:{"pagination":_vm.table.pagination}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }